"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchApp = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var web_base_1 = require("@tencent/web-base");
var config_context_1 = require("../_util/config-context");
var launch_1 = require("../enum/launch");
var pre_launch_1 = require("./launch/pre-launch");
var trigger_launch_1 = require("./launch/trigger-launch");
var get_scheme_1 = require("./launch/get-scheme");
var launch_component_1 = tslib_1.__importDefault(require("./components/launch-component"));
var andr_download_1 = tslib_1.__importDefault(require("./components/andr-download"));
var download_Info_1 = tslib_1.__importDefault(require("./components/download-Info"));
var init_aegis_1 = tslib_1.__importDefault(require("../_util/init-aegis"));
var download_1 = require("./launch/download");
var withReport_1 = require("../hoc/withReport");
/**
 * 微信scheme流程：
 * 企微scheme流程：
 */
var $LaunchApp = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, notCheckLogin = _a.notCheckLogin, code = _a.code, state = _a.state, _b = _a.type, type = _b === void 0 ? launch_1.EnumLaunchType.LaunchApp : _b, meetingCode = _a.meetingCode, meetingState = _a.meetingState, meetingType = _a.meetingType, joinToken = _a.joinToken, countryCode = _a.countryCode, customScheme = _a.schemeUrl, meetingId = _a.meetingId, _c = _a.showDetail, showDetail = _c === void 0 ? function () { return void 0; } : _c, _d = _a.showDownload, showDownload = _d === void 0 ? function () { return void 0; } : _d, uninstallCb = _a.uninstallCb, mode = _a.mode, launchMode = _a.launchMode, beaconReport = _a.beaconReport, aegis = _a.aegis, wxLaunchFailedCallback = _a.wxLaunchFailedCallback, queryLaunchTimeout = _a.queryLaunchTimeout, _e = _a.http, http = _e === void 0 ? {
        post: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, void 0];
        }); }); },
        get: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, void 0];
        }); }); },
    } : _e, wx = _a.wx, beginTime = _a.beginTime, _f = _a.isPmi, isPmi = _f === void 0 ? false : _f, children = _a.children, from = _a.from, rs = _a.rs, props = tslib_1.__rest(_a, ["className", "notCheckLogin", "code", "state", "type", "meetingCode", "meetingState", "meetingType", "joinToken", "countryCode", "schemeUrl", "meetingId", "showDetail", "showDownload", "uninstallCb", "mode", "launchMode", "beaconReport", "aegis", "wxLaunchFailedCallback", "queryLaunchTimeout", "http", "wx", "beginTime", "isPmi", "children", "from", "rs"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _g = tslib_1.__read((0, react_1.useState)(null), 2), initLaunchRes = _g[0], setInitLaunchRes = _g[1];
    var _h = tslib_1.__read((0, react_1.useState)(download_1.ELaunchAppState.SUCCESS), 2), launchAppState = _h[0], setLaunchAppState = _h[1]; // 是否成功拉起 app
    var _j = tslib_1.__read((0, react_1.useState)(false), 2), shouldShowGuide = _j[0], setShowGuide = _j[1];
    (0, react_1.useEffect)(function () {
        function init() {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var res, err_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            res = undefined;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, (0, pre_launch_1.initLaunch)({
                                    notCheckLogin: notCheckLogin,
                                    http: http,
                                    code: code,
                                    state: state,
                                    aegis: aegis,
                                })];
                        case 2:
                            res = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            console.error(err_1);
                            return [3 /*break*/, 4];
                        case 4:
                            setInitLaunchRes(res);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (!(0, web_base_1.isWechatMiniProgram)()) {
            init();
        }
        else {
            defaultWxLaunchFailedCallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        if (initLaunchRes !== null) {
            triggerLaunchApp();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initLaunchRes]);
    var triggerLaunchApp = function () {
        var curTime = (new Date()).getTime() / 1000;
        var durationSecond = ((Number(beginTime || 0)) - curTime);
        var duration = durationSecond < 0 ? '0' : (durationSecond / 60).toFixed(2);
        if (isPmi) {
            onClickPmi(duration);
        }
        else {
            onClickDetail(duration);
        }
    };
    // 检测scheme 是否合法
    var checkSchemeIsLegal = function (scheme) {
        var reg = /^[a-zA-Z]+:\/\/([\w.]+\/?)\S*/;
        if (scheme) {
            if (reg.test(scheme)) {
                return scheme;
            }
            console.warn("scheme ".concat(scheme, " is illegal"));
        }
        return undefined;
    };
    var defaultWxLaunchFailedCallback = function () {
        setShowGuide(true);
        if (type === launch_1.EnumLaunchType.MeetingCode && meetingCode) {
            init_aegis_1.default.logAll('[met-component-launchapp]arouse_fail_popout_explore_meetingCode');
            // beaconReport('web_launchapp_page_copypopup_null_null_null_explore', { fromSource: from });
            beaconReport('arouse_fail_popout_explore', {
                scenevalue: 1,
            });
        }
        if (type === launch_1.EnumLaunchType.LaunchApp) {
            var scenevalue = Number((0, web_base_1.getRequest)('scenevalue'));
            init_aegis_1.default.logAll('[met-component-launchapp]arouse_fail_popout_explore_launchApp');
            beaconReport('arouse_fail_popout_explore', {
                scenevalue: scenevalue,
            });
        }
    };
    // 拉起 app 时失败回调函数
    var wrappedLaunchFailedCallback = function () {
        console.warn('测试使用', '拉起失败回调: launchFailedCallback');
        setLaunchAppState(download_1.ELaunchAppState.FAILURE);
        beaconReport('web_launchapp_page_mask_null_null_null_explore', { fromSource: from, trigger: 'launch_fail' });
        typeof wxLaunchFailedCallback === 'function' ? wxLaunchFailedCallback() : defaultWxLaunchFailedCallback();
    };
    // 未安装，拉起 app 时失败回调函数
    var wrappedUninstallCb = function () {
        console.warn('测试使用', '未下载拉起失败回调: uninstallCallback');
        setLaunchAppState(download_1.ELaunchAppState.UNINSTALL);
        // beaconReport('web_launchapp_page_mask_null_null_null_explore', { fromSource: from, trigger: 'launch_fail' });
        typeof uninstallCb === 'function' && uninstallCb();
    };
    var onClickPmi = function (duration) {
        (0, trigger_launch_1.onClickJoinForPmi)({
            type: launch_1.EnumLaunchType.MeetingCode,
            duration: duration,
            meetingCode: meetingCode,
            meetingState: meetingState,
            meetingType: meetingType,
            joinToken: joinToken,
            initLaunchRes: initLaunchRes,
            countryCode: countryCode,
            customScheme: (0, get_scheme_1.getPmiScheme)(launch_1.EnumLaunchType.MeetingCode, meetingCode),
            meetingId: meetingId,
            showDetail: showDetail,
            showDownload: showDownload,
            uninstallCb: wrappedUninstallCb,
            beaconReport: beaconReport,
            wxLaunchFailedCallback: wrappedLaunchFailedCallback,
            queryLaunchTimeout: queryLaunchTimeout,
            http: http,
            wx: wx,
            aegis: aegis,
            from: from,
            rs: rs,
        });
    };
    var onClickDetail = function (duration) {
        (0, trigger_launch_1.onClickJoinForDetail)({
            type: type,
            duration: duration,
            meetingCode: meetingCode,
            meetingState: meetingState,
            meetingType: meetingType,
            joinToken: joinToken,
            initLaunchRes: initLaunchRes,
            countryCode: countryCode,
            customScheme: checkSchemeIsLegal(customScheme),
            meetingId: meetingId,
            showDetail: showDetail,
            showDownload: showDownload,
            uninstallCb: wrappedUninstallCb,
            mode: mode,
            beaconReport: beaconReport,
            wxLaunchFailedCallback: wrappedLaunchFailedCallback,
            queryLaunchTimeout: queryLaunchTimeout,
            http: http,
            wx: wx,
            launchMode: launchMode,
            aegis: aegis,
            from: from,
            rs: rs,
        });
    };
    return (react_1.default.createElement("div", tslib_1.__assign({}, props, { ref: ref, className: (0, classnames_1.default)("".concat(classPrefix, "-launch-app"), className) }),
        react_1.default.createElement(launch_component_1.default, { launchFunc: triggerLaunchApp, beaconReport: beaconReport, from: from, launchAppState: launchAppState }),
        (0, web_base_1.isMobile)() && react_1.default.createElement(download_Info_1.default, { http: http }),
        shouldShowGuide && react_1.default.createElement(andr_download_1.default, { closeAndrGuide: function () { return setShowGuide(false); } })));
});
$LaunchApp.displayName = 'LaunchApp';
exports.LaunchApp = (0, withReport_1.withReport)($LaunchApp);
//# sourceMappingURL=LaunchApp.js.map